import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import { getProfileOnboardingStep, setProfileOnboardingStep } from 'utils/localStorage';
import { setStep } from 'features/utilsSlice';
import { previewUrl } from 'utils/helpers';
import CheckInCircleIcon from 'public/icons/check-circle-green.svg';
import WhiteAlert from 'components/WhiteAlert';
import ShareDialog from 'components/ShareDialog';
import useCurrentProfile from 'hooks/useCurrentProfile';

const StepOne = ({ setStep }) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    setProfileOnboardingStep(2);
    dispatch(setStep(2));
  };

  return (
    <WhiteAlert
      title="Get started"
      description="Adjust your prices and verify any of your accounts on your profile below… Once done, click ‘Next Step’."
      buttonText="Next Step"
      iconSrc="/icons/question-circle.svg"
      alt="Question Mark"
      endIcon={<CheckInCircleIcon />}
      handleClick={handleClose}
      handleClose={handleClose}
    />
  );
};

const StepTwo = ({ setStep }) => {
  const dispatch = useDispatch();
  const [showShareDialog, setShowShareDialog] = useState(false);
  const profile = useCurrentProfile();

  return (
    <>
      <WhiteAlert
        title="Copy your link"
        description="and add to your social bios / send to anyone that wants to do business with you."
        buttonText="Copy link"
        iconSrc="/icons/copy.svg"
        alt="Copy"
        endIcon={<CheckInCircleIcon />}
        handleClick={() => setShowShareDialog(true)}
        handleClose={() => {
          setProfileOnboardingStep(3);
          dispatch(setStep(3));
        }}
      />

      <ShareDialog
        url={previewUrl(`/u/${profile.username}`)}
        open={showShareDialog}
        setOpen={setShowShareDialog}
        heading="Share your profile"
        copyLinkText="Copy My Profile Link"
      />
    </>
  );
};

const StepThree = ({ setStep }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  return (
    <WhiteAlert
      title="Discover & Purchase"
      description="Find paying gigs posted by brands or buy a shoutout to promote your socials from other influencers in discover."
      buttonText="Discover"
      iconSrc="/icons/search.svg"
      alt="Search"
      endIcon={<CheckInCircleIcon />}
      handleClick={() => {
        setProfileOnboardingStep(4);
        dispatch(setStep(4));
        router.push('/discover');
      }}
      handleClose={() => {
        setProfileOnboardingStep(4);
        dispatch(setStep(4));
      }}
    />
  );
};

const renderStep = (step, setStep) => {
  if (step === 1) return <StepOne setStep={setStep} />;
  if (step === 2) return <StepTwo setStep={setStep} />;
  if (step === 3) return <StepThree setStep={setStep} />;
  return null;
};

const ProfileOnboardingSteps = () => {
  const step = useSelector(state => state.utils.step);
  const dispatch = useDispatch();

  useEffect(() => {
    const profileOnboardingStep = getProfileOnboardingStep();
    dispatch(setStep(profileOnboardingStep));
  }, [dispatch]);

  return renderStep(step, setStep);
};

export default ProfileOnboardingSteps;
